import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initAnalytics, capture } from './analytics';
import { HelmetProvider } from 'react-helmet-async';

initAnalytics();

document.addEventListener('click', (event) => {
  const link = event.target.closest('a[data-funnel]');
  if (link) capture('f1000_funnel_action', { action: link.dataset.funnel, path: window.location.pathname, release: '2026-09-18' });
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
